import ImgVisualizer from './ImgVisualizer';

export default ImgVisualizer;
